import { render, staticRenderFns } from "./baseInfoCheckReturn.vue?vue&type=template&id=50e1194d&scoped=true"
import script from "./baseInfoCheckReturn.vue?vue&type=script&lang=js"
export * from "./baseInfoCheckReturn.vue?vue&type=script&lang=js"
import style0 from "./baseInfoCheckReturn.vue?vue&type=style&index=0&id=50e1194d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e1194d",
  null
  
)

export default component.exports